export class ProductDownloadReq{
    constructor(productCode: string, releaseNr: string) {
        this.productCode = productCode;
        this.releaseNr = releaseNr;
    }

    productCode: string;
    releaseNr: string;
}